<template>
    <WText
        :tag="tag"
        :align="align"
        :color="color"
        :underline="underline"
        :italic="italic"
        :size="size"
        :weight="weight"
    >
        {{ displayNumber }}
    </WText>
</template>

<script>
import VueTypes from 'vue-types'

export default {
    name: 'Counter',
    props: {
        number: VueTypes.number,
        delay: VueTypes.number.def(30),
        tag: VueTypes.string.def('span'),
        align: VueTypes.oneOf(['left', 'center', 'right', '']).def('left'),
        color: VueTypes.oneOf(['white', 'primary', 'secondary', 'gray', 'grayDark', 'dark', 'black', 'yellow', 'red', 'greenDark', '']).optional,
        size: VueTypes.oneOfType([String, Number]).optional,
        weight: VueTypes.oneOf(['light', 'medium', 'semi', 'bold', '']).def(''),
        underline: VueTypes.bool.def(false),
        italic: VueTypes.bool.def(false),
    },
    data () {
        return {
            displayNumber: 0,
            interval: false,
        }
    },
    watch: {
        number () {
            clearInterval(this.interval)
            if (this.number === this.displayNumber) return
            this.interval = window.setInterval(() => {
                if (this.displayNumber !== this.number) {
                    let change = (this.number - this.displayNumber) / 10
                    change = change >= 0 ? Math.ceil(change) : Math.floor(change)
                    this.displayNumber += change
                }
            }, this.delay)
        },

    },
    mounted () {
        this.displayNumber = this.number ? this.number : 0
    },
}
</script>
